import "$styles/index.css"

console.info("Bridgetown is loaded!")

document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".site-nav__toggle");
  const links = document.querySelector(".site-nav__links");
  if (toggle && links) {
    toggle.addEventListener("click", () => {
      const open = links.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(open));
    });
  }
});
